import React, { useState, useEffect, useContext } from "react";
import Header from "../components/application/header";
import Footer from "../components/application/footer";
import Sidebar from "../components/application/sidebar";
import HelpVideos from "../components/application/HelpVideos";
import PlanHeader from "../components/application/PlanHeader";
import ChoosePlans from "../components/application/ChoosePlans";
import SelfieModal from "../components/application/SelfieModal";
import ErrorBoundary from "../common/ErrorBoundary";

import { Route, Switch, useLocation } from "react-router-dom";
import routes from "./Routes";
import Logout from "../pages/logout";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import Utils from "./../common/Utils";
import { UserContext } from "../common";
import { IAgree } from "../public";
import {Card} from "react-bootstrap";


function App() {
  const [showNoti, setShowNoti] = useState(false);
  const [notiData, setNotiData] = useState([]);
  const { userData, showPlan, addToUserData } = useContext(UserContext);
  const [sidebar, showSidebar] = useState(true);
  const loc = useLocation();

  // start auto logout
  const [inactive, setInactive] = useState(false);

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setInactive(true), 1000 * 60 * 60 * 3); //== 3 hours
    };

    const clearTimer = () => {
      clearTimeout(timeout);
      setInactive(false);
    };

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "wheel", "resize"];

    events.forEach((event) => {
      document.addEventListener(event, resetTimer, { passive: true });
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (inactive) {
      window.location.href = `${process.env.PUBLIC_URL}/logout`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inactive]);

  // end auto logout
  const hideNoti = (e, nid) => {
    e.stopPropagation();
    const remainingData = _.filter(notiData, (n) => n.id !== nid);

    axios.post(Utils.apiUrl("tasks/hidenotification"), "nid=" + nid, Utils.apiHeaders()).then((res) => {
      if (res.data.success) {
        setNotiData(remainingData);
      }
    });
  };

  useEffect(function () {
    axios
      .get(Utils.apiUrl("tasks/getnotifications"), Utils.apiHeaders())
      .then((res) => {
        if(hasPlanAccess() && _.get(res,'data.forceLogout',false)){ //== already has access but plan expired then logout and reload
          if(Utils.getUserData()){
            Utils.setUserData(false);          
            window.location.reload();
          }
        }else if(!hasPlanAccess() && !_.get(res,'data.forceLogout',false)){ // == do not have access and plan renewed then also reload
          if(_.get(res.data,'plandata',false)){
            if (addToUserData) addToUserData(res.data.plandata);
            else Utils.addToUserData(res.data.plandata);
            window.location.reload();
          }          
        }
        else{
          if(_.get(res.data,'plandata',false)){
            if (addToUserData) addToUserData(res.data.plandata);
            else Utils.addToUserData(res.data.plandata);
          }
          if (_.get(res, "data.data", []).length > 0) {          
            setNotiData(res.data.data);
          }
        }
      })
      .catch((err) => {
        // do nothing
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (showNoti) {
      _.each(window.document.getElementsByClassName("notifyctrl"), (ele) => {
        if (ele.offsetLeft > 0) {
          window.document.getElementsByClassName("noticont")[0].style.width = window.document.body.offsetWidth - ele.offsetLeft + "px";
        }
      });
    }
  }, [showNoti]);

  const hasPlanAccess = () => {
    if(loc.pathname.includes('/logout')) return true;
    const planExpires = _.get(userData,'plan_expires',false);
    return !(userData.is_super_user && (planExpires===false || moment().isAfter(moment(planExpires))));
  };

  const showNoPlanBox = () => {
    return (
      <div className="dt-no-access-container mt-3">
        <div className="alert alert-danger d-flex align-items-center gap-3 p-3 mb-4 shadow-sm" style={{ borderRadius: "12px", borderLeft: "5px solid #dc3545" }}>
          <div style={{ fontSize: "28px" }}>⚠️</div>
          <div>
            <h4 className="alert-heading fw-bold mb-1">Subscription Inactive / Expired</h4>
            <p className="mb-0 text-muted" style={{ color: "#721c24" }}>
              Your subscription has expired, or the current plan is no longer active. 
              To continue enjoying full access to all clinical modules, please choose a plan below to activate your account.
            </p>
          </div>
        </div>
        <ChoosePlans />
      </div>
    );
  };

  return (
    <div className="dt-app-shell">
      <SelfieModal />
      <Sidebar />
      <div className="dt-main" id="layoutSidenav_content">
        <Header showNoti={showNoti} setShowNoti={setShowNoti} notiData={notiData} sidebar={sidebar} showSidebar={() => showSidebar(!sidebar)} />
        {showNoti && notiData.length === 0 && <div className="noticont nodata alert alert-warning">No Notifications found!</div>}
        {showNoti && notiData.length > 0 && (
          <div className="noticont">
            {notiData.map((nd) => (
              <div key={nd.id} className="notidata d-flex align-items-start justify-content-between gap-2">
                <div dangerouslySetInnerHTML={{ __html: nd.notification }} />
                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                  <span
                    className="clickable"
                    title="Mark as read"
                    onClick={(e) => hideNoti(e, nd.id)}
                  >
                    ✓
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="dt-canvas">
          <HelpVideos />
          <Route path={process.env.PUBLIC_URL + "/logout"} component={Logout} />
          {hasPlanAccess() && (
            <>
              {Boolean(userData?.first) && <IAgree />}
              {showPlan && <PlanHeader />}
              {!Boolean(userData?.first) && (
                <ErrorBoundary label={loc.pathname}>
                  <Switch>
                    {routes.map((r) => (
                      <Route key={r.path} path={process.env.PUBLIC_URL + r.path} component={r.component} />
                    ))}
                  </Switch>
                </ErrorBoundary>
              )}
            </>
          )}
          {hasPlanAccess() === false && showNoPlanBox()}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;